import React from 'react'
import { M_CheckBox, M_DrawerTableTextField, M_InputTextField, M_Select, M_TextArea } from 'src/M_Components'

export const changes = (field, value, setData) => {
    setData(prev => ({ ...prev, [field]: value }))
}

export const fields = (
    fields, index, data, setData, hideLabels, returnFunc,
    size, options, margin, noAutocomplete, submit, cancel, filter
) => {

    if (fields.type === 'select') {
        return (
            <div style={{ margin: '5px' }} key={index}>
                <M_Select
                    translate={fields?.translate}
                    margin={margin}
                    autocomplete={!noAutocomplete && true}
                    hasNone
                    size={size && size || '250px'}
                    label={hideLabels ? null : fields.display}
                    value={data && data[fields.code] != null && data[fields.code] !== '' ? {
                        label: data[fields.code],
                        value: data[fields?.extraField] != null ? data[fields?.extraField] : data[fields.code]
                    } : null}
                    options={data && data[fields?.options] || options && options || []}
                    onChangeValue={(obj) => {
                        if (returnFunc) {
                            returnFunc(data, fields, obj)
                            return
                        }
                        changes(fields.code, obj && obj.label || '', setData)
                        if (fields?.extraField) {
                            changes(fields.extraField, obj && obj.value || '', setData)
                        }
                    }}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    color={fields?.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields?.required && !data[fields.code] && 'var(--color-red)'}
                />
            </div>
        )
    }
    if (fields.type === 'foreignKey') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_DrawerTableTextField
                    translate={fields?.translate}
                    size={size && size || '250px'}
                    style={{ maxWidth: '250px' }}
                    tableLabel={fields?.entity}
                    label={hideLabels ? null : fields?.display}
                    entity={fields?.entity}
                    filterField={fields?.filterField}
                    labelFields={fields?.labelFields}
                    value={data && data[fields.code] != null && data[fields.code] !== '' ?
                        {
                        ...Object.assign({}, ...fields.fields.map(obj => ({ [obj.key]: data[obj.value] }))),
                        ...(fields.displayField ? { [fields.labelFields[0]]: data[fields.displayField] } : {})
                        }
                        : null}
                    onSubmitValue={(obj => {
                        if (returnFunc) {
                            returnFunc(data, fields, obj)
                            return
                        }
                        fields.fields?.map(keyValue => {
                            changes(keyValue.value, obj && obj[keyValue.key] != null ? obj[keyValue.key] : '', setData)
                        })
                    })}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    color={fields?.required && (data[fields.code] == null || data[fields.code] === '') && 'var(--color-red)'}
                    secondColor={fields?.required && (data[fields.code] == null || data[fields.code] === '') && 'var(--color-red)'}
                    FILTER={filter || fields?.FILTER || null}
                    api={fields?.api === 'secondary' ? 'secondary' : 'main'}
                />
            </div>
        )
    }
    if (fields.type === 'date' || fields.type === 'number' || fields.type === 'text' || fields.type === 'time') {
        return (
            <div style={{ margin: '5px', minWidth: '50px', }} key={index}>
                <M_InputTextField
                    translate={fields?.translate}
                    size={size && size || '250px'}
                    label={hideLabels ? null : fields.display}
                    type={fields.type}
                    value={data && data[fields?.code] != null ? data[fields?.code] : ''}
                    disabled={fields?.disabled || false}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    color={fields?.required && (data[fields.code] == null || data[fields.code] === '') && 'var(--color-red)'}
                    secondColor={fields?.required && (data[fields.code] == null || data[fields.code] === '') && 'var(--color-red)'}
                    onChange={(e) => {
                        if (returnFunc) {
                            returnFunc(data, fields, e.target.value)
                            return
                        }
                        changes(fields.code, e.target.value, setData)
                    }}
                    submit={submit}
                    cancel={cancel}
                />
            </div>
        )
    }
    if (fields.type === 'decimal') {
        return (
            <div style={{ margin: '5px', minWidth: '50px', }} key={index}>
                <M_InputTextField
                    translate={fields?.translate}
                    size={size && size || '250px'}
                    label={hideLabels ? null : fields.display}
                    type="text"
                    value={data && data[fields?.code] != null ? data[fields?.code] : ''}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    color={fields?.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields?.required && !data[fields.code] && 'var(--color-red)'}
                    onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^0-9.,]/g, '');
                        value = value.replace(/,/g, '.'); 
                        
                        const parts = value.split('.');
                        if (parts.length > 2) {
                            value = parts[0] + '.' + parts.slice(1).join('');
                        }
                        
                        if (returnFunc) {
                            returnFunc(data, fields, value)
                            return
                        }
                        changes(fields.code, value, setData)
                    }}
                    submit={submit}
                    cancel={cancel}
                />
            </div>
        )
    }
    if (fields.type === 'textArea') {
        return (
            <div style={{ margin: '5px', minWidth: '50px', }} key={index}>
                <M_TextArea
                    translate={fields?.translate}
                    size={size && size || '250px'}
                    rows={2}
                    label={hideLabels ? null : fields.display}
                    type={fields.type}
                    value={data[fields.code] != null ? data[fields.code] : ''}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    color={fields?.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields?.required && !data[fields.code] && 'var(--color-red)'}
                    onChange={(e) => {
                        if (returnFunc) {
                            returnFunc(data, fields, e.target.value)
                            return
                        }
                        changes(fields.code, e.target.value, setData)
                    }}
                />
            </div>
        )
    }
    if (fields.type === 'disabled') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_InputTextField
                    translate={fields?.translate}
                    size={size && size || '250px'}
                    disabled
                    label={hideLabels ? null : fields.display}
                    value={data[fields.code] != null ? data[fields.code] : ''}
                />
            </div>
        )
    }
    if (fields.type === 'checkBox') {
        return (
            <div style={{ margin: '5px', width: 'auto' }} key={index}>
                <M_CheckBox
                    translate={fields?.translate}
                    required={hideLabels ? null : fields?.required && fields?.required || false}
                    label={hideLabels ? null : fields.display}
                    checked={data[fields.code] || false}
                    onChange={(e) => {
                        if (returnFunc) {
                            returnFunc(data, fields, e.target.checked)
                            return
                        }
                        changes(fields.code, e.target.checked, setData)
                    }}
                />
            </div>
        )
    }
    if (fields.type === 'whitespace') {
        return (
            <div style={{ margin: '5px' }} key={index}></div>
        )
    }
}